import CookieConsent from 'react-cookie-consent';
import { useNavigate } from 'react-router-dom';

const CustomCookieConsent = () => {
  const navigate=useNavigate()
  return (
   <div>
     <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Deny"
      enableDeclineButton={true}
      containerClasses="cookie-consent-container"
       buttonWrapperClasses="cookie-consent-buttons"
      buttonClasses="cookie-consent-button accept"
      declineButtonClasses="cookie-consent-button deny"
      contentClasses="cookie-consent-content"
    >
     This site uses cookies to make it work properly, help us to understand how it's used and to display content that is more relevant to you. For more information, see our <span onClick={()=>navigate("/terms-of-service")} className='cookie-policy-link'>Cookie Policy</span> .
    </CookieConsent>
   </div>
  );
};

export default CustomCookieConsent;
